import { Component, OnInit } from '@angular/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { AlertController, NavController } from '@ionic/angular';
import { PwaService } from './services/pwa.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  tab: string = '';
  darkMode: boolean = false;
  private sub?: Subscription;

  get showSidebarMenu(): boolean {
    let str = window.location.href;
    let param = str.split('/');
    return param.includes('');
  }

  get isWeb(): boolean {
    return window.innerWidth >= 768 ? true : false;
  }

  toggleDarkMode(shouldEnable: boolean) {
    document.body.classList.toggle('dark', shouldEnable);
    localStorage.setItem('dark-mode', String(shouldEnable));
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  constructor(
    private navCtrl: NavController,
    private alertController: AlertController,
    public pwa: PwaService
  ) {
    SplashScreen.show({
      showDuration: 2000,
      autoHide: true,
    });
  }

  ngOnInit(): void {
    const prefersDark = localStorage.getItem('dark-mode') === 'true';
    this.darkMode = prefersDark;
    this.toggleDarkMode(prefersDark);
    let url = window.location.href;
    if (url.split('/').includes('care-smbt.synth365.com')) {
      localStorage.setItem('connectFor', 'Clinics');
    } else {
      localStorage.setItem('connectFor', 'beta');
    }
  }

  logout() {
    sessionStorage.clear();
    localStorage.clear();
    this.navCtrl.navigateRoot(['./login']);
  }

  openPage(page: string) {
    try {
      this.tab = page;
      this.navCtrl.navigateRoot([`./${page}`]);
    } catch (error) { }
  }

  async presentLogoutAlert() {
    const alert = await this.alertController.create({
      header: 'Are you sure you want to logout?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Yes Please!',
          handler: () => {
            this.logout(); // Replace with your logout logic
          },
        },
      ],
    });

    await alert.present();
  }
}
